import { render, staticRenderFns } from "./y_upload_video.vue?vue&type=template&id=c2a2f4f0&scoped=true"
import script from "./y_upload_video.vue?vue&type=script&lang=js"
export * from "./y_upload_video.vue?vue&type=script&lang=js"
import style1 from "./y_upload_video.vue?vue&type=style&index=1&id=c2a2f4f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a2f4f0",
  null
  
)

export default component.exports